<template>
  <!-- 认证弹窗certification -->
  <div class="certification">
    <!-- height="460px" -->
    <el-dialog
      title="手机号注册"
      width="366px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <img src="../../assets/img/手机.png" alt="" />
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item prop="phone" label="手机号:">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>

        <el-form-item prop="LoginPwd" label="密码:">
          <el-input v-model="form.LoginPwd" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item prop="repassword" label="确认密码:">
          <el-input
            v-model="form.repassword"
            placeholder="请再次输入密码"
          ></el-input>
        </el-form-item>
        <!-- 邮箱 -->
        <el-form-item prop="MailBox" label="邮箱:">
          <el-input
            class="MailBox"
            v-model="form.MailBox"
            placeholder="请输入邮箱（用于找回密码请必填）"
          ></el-input>
        </el-form-item>
        <!-- 职位名称 -->
        <el-form-item prop="UserIdentityID" label="身份:">
          <!-- <el-input
            v-model="form.PostsName"
            placeholder="请输入身份"
          ></el-input> -->
          <el-select v-model="form.UserIdentityID" placeholder="请选择身份">
            <el-option
              v-for="item in option_s"
              :key="item.ID"
              :label="item.UserIdentity"
              :value="item.ID"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 选择区域 -->
        <el-form-item prop="RegionCode" label="区域:">
          <el-cascader
            placeholder="请选择区域"
            :options="options"
            v-model="form.RegionCode"
            @change="handleChange"
            clearable
          ></el-cascader>
        </el-form-item>

        <!-- 滑块 -->
        <!-- <Slider
          @onSuccess="onSuccess"
          class="sliderMargin"
          @isOk="isOk"
          ref="sider"
        ></Slider> -->

        <el-button type="primary" @click="submitForm" v-loading="loading"
          >提交</el-button
        >
      </el-form>
      <!-- 用户服务协议 -->
      <div class="user_userAgreement">
        <el-checkbox v-model="checked"
          ><span>我已阅读并同意</span>
        </el-checkbox>
        <span class="UserAgreement" @click="UserAgreementHandle"
          >《用户服务协议》</span
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import text from "../../../static/districts.json";
// 引入接口
import {
  UserAuthenticationInfo,
  GetVerificationCode,
  RegisteredAccount,
  GetUserIdentityList
} from "@/api/user.js";
import Slider from "@/components/siders";
export default {
  name: "certification",
  components: {
    Slider
  },
  props: {
    loginsInfo: {
      // 表格数据
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    var repasswordValidator = (rules, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value != this.form.LoginPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      // 表单数据
      form: {
        phone: "",
        Area: "",
        Region: "", //选择器选择的省市区
        RegionCode: "",
        UserIdentityID: "",
        LoginPwd: "",
        repassword: "",
        MailBox: ""
      },
      validation: {
        Phone: "",
        VerificationCode: ""
      },

      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            required: true,
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur"
          }
        ],
        LoginPwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
        repassword: [{ validator: repasswordValidator, trigger: "blur" }],
        MailBox: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        UserIdentityID: [
          { required: true, message: "请选择身份信息", trigger: "blur" }
        ],
        RegionCode: [{ required: true, message: "请选择地区", trigger: "blur" }]
      },
      options: [],
      option_s: [],
      cityArr: [], //城市列表
      // areaArr: [], //区县列表
      province: "", //省
      city: "", //市
      area: "", // 区县,
      provinceCityArea: "", //选择器选择的省市区
      // 滑块事件
      sliderEvent: false,
      loading: "",
      checked: ""
    };
  },
  computed: {
    hasToken: {
      get() {
        return this.$store.state.users.token;
      }
    },
    userInfos: {
      get() {
        return this.$store.state.users.userInfo;
      }
    },
    dialogVisible: {
      get() {
        return this.loginsInfo.dialogVisible;
      },
      set(value) {
        this.$emit("update:visible", value);
      }
    }
  },
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();
      this.$emit("update:visible", false);
    },
    // 注册
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (!this.checked) {
            this.$message({
              message: "请勾选用户协议!",
              type: "warning",
              customClass: "messageIndex"
            });
          } else {
            this.loading = true;
            RegisteredAccount(this.form)
              .then(res => {
                console.log("res", res);
                this.$message({
                  message: res.Msg,
                  type: "success"
                });
                this.$refs["form"].resetFields();
                this.checked = false;
                this.loading = false;
                this.dialogVisible = false;
              })
              .catch(err => {
                this.loading = false;
                this.$refs["form"].resetFields();
                this.checked = false;
                console.log("err", err);
                this.$message.error(err);
              });
          }
        } else {
          this.$message({
            message: "请填写正确的信息",
            type: "warning",
            customClass: "messageIndex"
          });
          return false;
        }
      });
    },
    // 跳转到用户协议
    UserAgreementHandle() {
      this.$router.push("/UserAgreement");
      this.$emit("update:visible", false);
    },
    // 获取地区信息
    initDistPicker() {
      let self = this;
      let distData = text;
      let options = [];
      // 省
      for (var provinceKy in distData["100000"]) {
        let optProvinceItem = {
          value: provinceKy,
          label: distData["100000"][provinceKy]
        };
        if (distData[provinceKy]) {
          // 市
          for (var cityKy in distData[provinceKy]) {
            optProvinceItem.children = optProvinceItem.children
              ? optProvinceItem.children
              : [];
            let optCityItem = {
              value: cityKy,
              label: distData[provinceKy][cityKy]
            };
            if (distData[cityKy]) {
              // 区
              // for (var areaKy in distData[cityKy]) {
              //   optCityItem.children = optCityItem.children
              //     ? optCityItem.children
              //     : [];
              //   let optAreaItem = {
              //     value: areaKy,
              //     label: distData[cityKy][areaKy]
              //   };
              //   optCityItem.children.push(optAreaItem);
              // }
            }
            optProvinceItem.children.push(optCityItem);
          }
        }
        options.push(optProvinceItem);
      }
      self.distData = distData;
      self.options = options;
      // });
    },
    handleChange(value) {
      let self = this;
      console.log("value=>", value);
      this.form.RegionCode = value;
      //获取省名
      self.options.map((item, index) => {
        if (item.value == value[0]) {
          self.cityArr = item.children; //存储城市列表
          self.province = item.label;
        }
      });
      //获取市名
      self.cityArr.map((item, index) => {
        if (item.value == value[1]) {
          self.areaArr = item.children; //存储区县列表
          self.city = item.label;
        }
      });
      //获取区县名
      // self.areaArr.map((item, index) => {
      //   if (item.value == value[2]) {
      //     self.area = item.label;
      //   }
      // });
      self.form.Region = self.province + self.city + self.area;
      console.log(this.form);
    },
    // 获取用户身份
    getGetUserIdentityList() {
      GetUserIdentityList().then(res => {
        console.log("res", res);
        this.option_s = res.Data;
      });
    }
  },
  created() {
    // 获取地区信息
    this.initDistPicker();
    // 获取用户身份
    this.getGetUserIdentityList();
  }
};
</script>

<style>
.sliderMargin {
  margin: 23px 0px 40px;
}
.user_userAgreement {
  margin-top: 23px;
}
.messageIndex {
  margin-top: 80px;
  z-index: 9999 !important;
  /* // 设置的值一定要比2007大，因为dialog的层级是2007 */
}
.el-message {
  top: 20px !important;
}
.el-message:not(:last-child) {
  visibility: hidden;
}
</style>

<style lang="less" scoped>
/deep/ .MailBox {
  width: 245px;
}
/deep/ .el-form-item {
  display: flex;
  border-bottom: 1px solid #ebebeb;
}

/deep/ .messageIndex {
  z-index: 9999 !important;
  /* // 设置的值一定要比2007大，因为dialog的层级是2007 */
}
/deep/.el-dialog__header {
  padding: 65px 20px 10px;
}
/deep/.el-dialog {
  width: 366px;
  // height: 460px;
  background: #ffffff;
  border-radius: 10px;
}

.certification {
  position: relative;
  // background: url(../../assets/img/盾牌保险认证.png) no-repeat;
  // background-size: 20px 20px;
  // top: 0px;
  img {
    position: absolute;
    top: 68px;
    left: 120px;
  }
  .code {
    position: absolute;
    top: 220px;
    left: 200px;
  }
  .msg_btn {
    position: absolute;
    top: 230px;
    left: 200px;
  }
}
.certification /deep/.el-input__inner {
  // margin-bottom: 29px;
  background-color: #fff;
  border: none;
  border-radius: 1px;
  // width: 266px;
  /* border: 1px solid #dcdfe6; */
  height: 45px;
  line-height: 60px;
  // border-bottom: 1px solid #ebebeb;
}
.el-button--primary {
  width: 266px;
  height: 40px;
  background: #5b90f0;
  border: 1px solid #ebebeb;
  border-radius: 6px;
  text-align: center;
}
/deep/.el-form-item__content {
  margin: 0px 0px 0px !important;
}
.el-input__prefix,
.el-input__suffix {
  height: 0px !important;
}
// 错误提示
/deep/.el-form-item__error {
  position: absolute;
  top: 100%;
  left: 30px !important;
}
// 按钮上边距
.el-button--primary[data-v-35056f12] {
  margin-top: 40px;
}
// 复选框，选中
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #656565;
}
// 用户协议
.UserAgreement {
  cursor: pointer;
  color: #5b90f0;
}
</style>

<style scoped lang="less">
/deep/.el-dialog__header {
  border-bottom: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog/Registered.vue